<template>
    <div class="clear-both"></div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <div>
        <button class="btn-indigo mx-5 mt-5" @click="switchCurrency('original')">Original</button>
        <button class="btn-indigo mx-5 mt-5" @click="switchCurrency('usd')">USD</button>
      </div>
    </div>
</template>

<script>

import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Cookies from 'js-cookie';

import VueDatepicker from '@vuepic/vue-datepicker'
// import '@vuepic/vue-datepicker/dist/vue-datepicker.css';
import '@vuepic/vue-datepicker/dist/main.css';

/*import { ref, onMounted } from 'vue'
const date = ref();

onMounted(() => {
  const startDate = new Date();
  const endDate = new Date(new Date().setDate(startDate.getDate() + 7));
  date.value = [startDate, endDate];
})*/

export default {
  components: {
    Head,
    VueDatepicker,
  },
  props: {
    statistics: {
      type: Object,
      required: true
    },
    totalsByDay: {
      type: Object,
      required: true
    },
    totals: {
      type: Object,
      required: true
    }
  },
  layout: Layout,
  data() {
    return {
    };
  },
  computed: {

  },
  methods: {
    handleDateChange(selectedDate) {
      console.log(selectedDate);
    },
  }

}
</script>

<style>
:root {
  --dp-font-size: 12.8px;
}

.dp__menu {
  font-size: var(--dp-font-size);
}
</style>